var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSmsMessage = function SvgSmsMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 47,
    viewBox: "0 0 34 47",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2381 0H21.0476C22.836 0 24.2857 1.44976 24.2857 3.2381V43.7143C24.2857 45.5026 22.836 46.9524 21.0476 46.9524H3.2381C1.44976 46.9524 0 45.5026 0 43.7143V3.2381C0 1.44976 1.44976 0 3.2381 0Z",
    fill: "#7D8D9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.28516H24.2857V40.4756H0V7.28516Z",
    fill: "#87CEE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47656 3.23828H17.8099V4.85733H6.47656V3.23828Z",
    fill: "#AABECE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5244 42.9062H13.7625V44.5253H10.5244V42.9062Z",
    fill: "#AABECE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42871 9.71484H5.66681V11.3339H2.42871V9.71484Z",
    fill: "#E9686A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28613 9.71484H10.5242V11.3339H7.28613V9.71484Z",
    fill: "#E9686A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7617 12.9531H15.3808V14.5722H13.7617V12.9531Z",
    fill: "#E9686A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11.334H18.619V14.5721H17V11.334Z",
    fill: "#E9686A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2383 9.71484H21.8573V14.572H20.2383V9.71484Z",
    fill: "#E9686A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0957 17.8105H34.0005V35.6201H8.0957V17.8105Z",
    fill: "#FCF05A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0957 17.8105L21.0481 27.5248L34.0005 17.8105H8.0957Z",
    fill: "#FDBD40"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmsMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sms-message.7b13cc3f.svg";
export { ForwardRef as ReactComponent };